import { StateCreator } from 'zustand'
import { OrgType } from 'app/dataTypes/org/types'
import { FilterValues, DraftsSlice, FilterStore } from './types'
import { calcDefaultPeriod } from './defaultPeriod'

const emptyDraft: FilterValues = {
  orgType: OrgType.School,
  orgIds: undefined,
  buildingIds: undefined,
  schoolYearId: undefined,
  period: calcDefaultPeriod(),
  saleTypeIds: undefined,
  foodModeIds: undefined,
  customerTypeIds: undefined,
  salePointIds: undefined,
  employeeIds: undefined,
  mail: 'do_not_mail',
  // ADD HERE
}

export const createDraftsSlice: StateCreator<FilterStore, [], [], DraftsSlice> = (set, get) => ({
  draft: emptyDraft,

  setDraft(values) {
    set((state) => ({
      draft: {
        ...state.draft,
        ...values,
      },
    }))
  },

  resetDraft() {
    set({
      draft: {
        ...get().defaults,
      },
    })
  },

  resetDraftByKey(key: keyof FilterValues) {
    set({
      draft: {
        ...get().draft,
        [key]: get().defaults[key],
      },
    })
  },
})
